import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5740296f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5740296f')) {
      api.createRecord('5740296f', component.options)
    } else {
      api.reload('5740296f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5740296f&", function () {
      api.rerender('5740296f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/systemLog/index.vue"
export default component.exports